import { onLCP, onFCP, onTTFB } from 'web-vitals'
import { sendPv } from '@/utils/logTrack'

function capturePerformanceTiming() {
  onLCP(sendMetric)
  onFCP(sendMetric)
  onTTFB(sendMetric)
  getFCP()
}

function getFCP() {
  const pf = performance.getEntriesByType('navigation')
  const end = pf[0]?.domContentLoadedEventEnd
  const start = pf[0]?.startTime
  const time = end - start
  console.log('首屏加载time', start, end, time)
  if (time) {
    sendMetric({
      value: time,
      name: 'fcp'
    })
  }
}

function sendMetric({ name, value, navigationType = '' }) {
  sendPv({
    md: 'performance',
    ct: 'web_time_sf',
    ctvl: window.location.pathname,
    ctnm: value,
    pds: name,
    extra: navigationType
  })
}

export default capturePerformanceTiming
